import React, { useState, useCallback, useMemo } from "react";
import { Card, Table, Modal, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import {Link} from 'react-router-dom';
import PlatformForm from "../forms/platformForm";
import { deletePlatform} from "../../stateManagement/actions/data";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const PlatformsList = ({list, reloadData}) => {

    const dispatch = useDispatch();

    // Consolidated modal state management
    const [modalState, setModalState] = useState({
        newPlatform: { visible: false },
        deletePlatform: { visible: false, id: null },
        editPlatform: {visible: false, id: null }
    });

    // Memoized modal handlers to prevent unnecessary recreations
    const showNewPlatformModal = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newPlatform: { visible: true }
        }));
    }, []);

    const handleNewPlatformCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newPlatform: { visible: false }
        }));
    }, []);

    const showDeletePlatformModal = useCallback((id) => {
        setModalState(prev => ({
            ...prev, 
            deletePlatform: { visible: true, id }
        }));
    }, []);

    const handleDeletePlatformCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            deletePlatform: { visible: false, id: null }
        }));
    }, []);

    const showEditPlatformModal = useCallback((id) => {
        setModalState(prev => ({
            ...prev, 
            editPlatform: { visible: true, id }
        }));
    }, []);

    const handleEditPlatformCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            editPlatform: { visible: false, id: null }
        }));
    }, []);

    // Memoized columns to prevent unnecessary recreations
    const PlatformsColumns = useMemo(() => [
        {
            key: 'platformProviderName',
            title: 'Platform name (UI)',
            dataIndex: 'platformProviderName',
            width: 120,
            ellipsis: true
        },
        {
            key: 'reportProviderName',
            title: 'Platform name (report)',
            dataIndex: 'reportProviderName',
            width: 120,
            ellipsis: true
        },
        {
            key: 'netRevenueForOpenAdjustment',
            title: 'Net rev. share for ORTB',
            dataIndex: 'netRevenueForOpenAdjustment',
            ellipsis: true
        },
        {
            key: 'netRevenueForDealsAdjustment',
            title: 'Net rev. share for deals',
            dataIndex: 'netRevenueForDealsAdjustment',
            ellipsis: true
        },
        {
            key: 'currency',
            title: 'Currency',
            dataIndex: 'currency',
            ellipsis: true
        },
        // {
        //     key: 'mainSheetName',
        //     title: 'Main sheet name (report)',
        //     dataIndex: 'mainSheetName',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'headersRow',
        //     title: 'Header row (report)',
        //     dataIndex: 'headersRow',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'dateColumn',
        //     title: 'Date column',
        //     dataIndex: 'dateColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'publisherColumn',
        //     title: 'Publisher column',
        //     dataIndex: 'publisherColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'websiteColumn',
        //     title: 'Website column',
        //     dataIndex: 'websiteColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'placementColumn',
        //     title: 'Placement column',
        //     dataIndex: 'placementColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'placementGroupColumn',
        //     title: 'Placement group column',
        //     dataIndex: 'placementGroupColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'auctionTypeColumn',
        //     title: 'Auction type column',
        //     dataIndex: 'auctionTypeColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'dealNameColumn',
        //     title: 'Deal name column',
        //     dataIndex: 'dealNameColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'mediaTypeColumn',
        //     title: 'Media type column',
        //     dataIndex: 'mediaTypeColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'adRequestColumn',
        //     title: 'Ad requests column',
        //     dataIndex: 'adRequestColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'impressionsColumn',
        //     title: 'Impressions column',
        //     dataIndex: 'impressionsColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'viewableimpressionsColumn',
        //     title: 'Viewable imps. column',
        //     dataIndex: 'viewableimpressionsColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'revenueColumn',
        //     title: 'Revenue column',
        //     dataIndex: 'revenueColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'cpmColumn',
        //     title: 'CPM column',
        //     dataIndex: 'cpmColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        // {
        //     key: 'clicksColumn',
        //     title: 'Clicks column',
        //     dataIndex: 'clicksColumn',
        //     width: 120,
        //     ellipsis: true
        // },
        {
            key: 'action',
            title: 'Actions',
            render: (data) => (<>
                <Tooltip title="Edit"><EditOutlined onClick={() => showEditPlatformModal(data._id)} style={{ color: 'orange', fontSize: '16px', margin: "8px" }}/></Tooltip>
                <Tooltip title="Delete"><DeleteOutlined onClick={() => showDeletePlatformModal(data._id)} style={{ color: 'red', fontSize: '16px', margin: "8px" }}/></Tooltip>
            </>)
        }
    ], [showEditPlatformModal, showDeletePlatformModal])

    // Memoized delete handler
    const handleDelete = useCallback(() => {
        dispatch(deletePlatform(modalState.deletePlatform.id));
        reloadData();
        handleDeletePlatformCancel()
    }, [
        dispatch, 
        modalState.deletePlatform.id, 
        reloadData, 
        handleDeletePlatformCancel
    ]);

    return(<>
        <Modal 
            title="Add new Platform" 
            open={modalState.newPlatform.visible} 
            onCancel={handleNewPlatformCancel}
            footer={null}
        >
            <PlatformForm 
                reloadData={reloadData} 
                onSubmitType="add"
            />
        </Modal>
        <Modal 
            title="Edit platform" 
            open={modalState.editPlatform.visible} 
            onCancel={handleEditPlatformCancel}
            footer={null}
        >
            <PlatformForm
                reloadData={reloadData}
                onSubmitType="edit"
                platformData={list ? list.filter(platform => platform._id === modalState.editPlatform.id)[0] : {}}
            />
        </Modal>
        <Modal 
            title="Confirmation required" 
            open={modalState.deletePlatform.visible} 
            onCancel={handleDeletePlatformCancel}
            onOk={handleDelete}
        >
            <p>Are you sure?</p>
        </Modal>
        <Card title="Platforms list:" size="small" extra={<Link onClick={showNewPlatformModal}>New</Link>}>
            <Table 
                columns={PlatformsColumns} 
                dataSource={list} 
                rowKey="_id"
                scroll={{ x: true}}
                style={{ maxWidth: "80vw" }}
                pagination={{
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total: ${total}`
                }}
            />            
        </Card>
    </>)
}

export default PlatformsList;